import { FC, ReactNode } from "react";
import Dialog from "./Dialog";
import { useDialogStore } from "./dialogStore";

type Props = {
  children: ReactNode;
};

/**
 * DialogProvider renders all active dialogs from the dialog store.
 * Wrap your app with this provider to enable dialog management.
 */
const DialogProvider: FC<Props> = ({ children }) => {
  const { dialogs, closeDialog, removeDialog } = useDialogStore();

  return (
    <>
      {children}
      {Object.entries(dialogs).map(([key, config]) => (
        <Dialog
          key={key}
          config={config}
          open={!config.closing}
          onClose={() => closeDialog(key)}
          onExited={() => removeDialog(key)}
        />
      ))}
    </>
  );
};

export default DialogProvider;
